import NotificationPersistenceService from 'app/services/NotificationPersistenceService';

const AuthService = {
  logout: () => {
    // Clear all authentication related data
    localStorage.removeItem('user_token');
    localStorage.removeItem('_grecaptcha');
    sessionStorage.clear();

    // Clear run-logs-related localStorage (subscriptions, connection state, etc.)
    try {
      NotificationPersistenceService.getInstance().clearAllData();
    } catch (error) {
      // no-op
    }

    // Redirect to login page
    window.location.href = '/login';
  },

  getUser: () => {
    const token = localStorage.getItem('user_token');
    return token ? JSON.parse(token) : null;
  },

  isAuthenticated: () => !!localStorage.getItem('user_token'),
};

export default AuthService; 